/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */
export default {
  active: 'is-active',
  added: 'is-added',
  collapsed: 'is-collapsed',
  disabled: 'is-disabled',
  hidden: 'is-hidden',
  lazyload: 'lazyload',
  lazyloaded: 'lazyloaded',
  loading: 'is-loading',
  removing: 'is-removing',
  sticky: 'is-sticky',
  tabbable: 'is-tabbable'
};